import omit from 'lodash/omit';

import React from 'react';
import PropTypes from 'prop-types';

import InputComponent from './Component';

class InputContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      isPopupVisible: false
    };

    this.handleAlertTriangleMouseEnter = () =>
      this.setState({ isPopupVisible: true });

    this.handleAlertTriangleMouseLeave = () =>
      this.setState({ isPopupVisible: false });

    this.handleOnBlur = event => {
      const { onBlur } = this.props.input;
      const { normalizeValue } = this.props;
      const { value } = event.target;

      if (normalizeValue) {
        onBlur(normalizeValue(value));
      }
    };
  }

  get showAlertTriangle () {
    return this.props.meta.invalid;
  }

  render () {
    const parsedLabel = this.props.label.split('\\n').map(message => <React.Fragment key={message}>{message}<br /></React.Fragment>);
    return (
      <InputComponent
        {...this.state}
        {...omit(this.props, [
          'meta',
          'input',
          'label'
        ])}
        {...this.props.meta}
        {...this.props.input}
        onBlur={this.handleOnBlur}
        label={parsedLabel}
        showAlertTriangle={this.showAlertTriangle}
        onAlertTriangleMouseEnter={this.handleAlertTriangleMouseEnter}
        onAlertTriangleMouseLeave={this.handleAlertTriangleMouseLeave}
      />
    );
  }
}

InputContainer.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object.isRequired,
  normalizeValue: PropTypes.func,
  meta: PropTypes.shape({
    invalid: PropTypes.bool.isRequired,
    touched: PropTypes.bool.isRequired
  }).isRequired
};

export default InputContainer;
